import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;
